import styles from "../styles/module/booking.module.css"
import '../styles/Menu.css';
import Form from "../components/Booking/Form.js";
import {Link} from "react-router-dom";
import {addressExport, googleMapsLink, linkLogoWhite, phoneExport, timeExport} from "../components/layout/Header.jsx";
import {GrMapLocation} from "react-icons/gr";
import {MdOutlinePhoneInTalk} from "react-icons/md";
import {CiClock2} from "react-icons/ci";
 

function Booking(props) {

    return (
        <>
            <div className={"container-booking"}>
                <section className={styles.wrapper}>
                    <div className={styles.top}>Tisch reservieren</div>
                    <div className={styles.bottom} aria-hidden="true">Tisch reservieren</div>
                </section>
                <ContainerBooking/>
            </div>

        </>
    )


}

export const ContainerBooking = () => {
    const dataCards = [
        {
            "title": "Hygienic Food",
            "description": "Wir verwenden stets frische, saubere Zutaten und garantieren hygienische Zubereitung, damit unsere Gäste mit absoluter Sicherheit genießen können.",
            "icon": "/assets/images/features-icon-1.png",
        },
        {
            "title": "Fresh Environment",
            "description": "Unser Restaurant bietet eine frische und angenehme Atmosphäre, die ein entspanntes und vollständiges Genusserlebnis ermöglicht.",
            "icon": "/assets/images/features-icon-2.png"
        },
        {
            "title": "Skilled Chefs",
            "description": "Unser erfahrenes Küchenteam kreiert mit Leidenschaft raffinierte Gerichte, die Tradition und Moderne perfekt verbinden.",
            "icon": "/assets/images/features-icon-3.png"
        },
        {
            "title": "Event & Party",
            "description": "Wir bieten flexible Räumlichkeiten und abwechslungsreiche Menüs für Ihre privaten Feiern und Veranstaltungen.",
            "icon": "/assets/images/features-icon-4.png"
        }
    ];

    return <div>
        <div className={styles.wrapSection}>
            <section className={`${styles.sectionFindTable} ${styles.section}`}>
                <div className={styles.containerText}>
                    <div className={styles.quote}>”</div>
                    <p className={styles.headline2}>
                        Vielen Dank für Ihren Besuch im Restaurant Kando. Wir freuen uns über Ihre netten Worte und
                        hoffen, Sie bald wieder begrüßen zu dürfen.
                    </p>

                    <div className={styles.wrapperSection}>
                        <div className={styles.separator}></div>
                        <div className={styles.separator}></div>
                        <div className={styles.separator}></div>
                    </div>
                </div>
            </section>
            <div className={styles.containerForm}>
                <div className={styles.wrapBooking}>
                    <div className={styles.formBooking}>
                        <Form/>
                    </div>
                    <div className={styles.container}>
                        <h1 className={styles.welcome}>WILLKOMMEN BEIM</h1>
                        <h2 className={styles.logo}>
                            <Link to="/">
                                <img src={linkLogoWhite}
                                     alt=""/>
                            </Link>
                        </h2>

                        <div className={styles.divider}>
                            <img src="/assets/images/Group-20.png" alt=""/>
                        </div>
                        <div className={styles.menuContainer}>
                            <div className={styles.wrapInfoMenu}>
                                <div
                                    className={`${styles.stuff} ${styles.link}`}
                                    onClick={() => {
                                        window.open(googleMapsLink, '_blank');
                                    }}
                                >
                                    <GrMapLocation/>
                                    {addressExport}
                                </div>
                                <div className={styles.stuff}>
                                    <MdOutlinePhoneInTalk/>
                                    {phoneExport}
                                </div>
                                <div className={styles.stuff}>
                                    <CiClock2/>
                                    {timeExport}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.containerFeature}>
                    <div className={styles.wrapTitle}>
                        <div className={styles.title}>

                            <div className={`${styles.orDivider} ${styles.justifyCenter}`}>
                                <div className={styles.iconTitle}>
                                    <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                         className=" "/>
                                </div>
                                <div className={styles.wrapOrDivider}>
                                    Why Choose Us
                                    <img src="/assets/icon/svg/separator.svg" alt=""/>
                                </div>
                            </div>
                        </div>
                        <h2 className={styles.sectionTitle}>Our Strength</h2>
                    </div>
                    <ul className={styles.listCardFeature}>
                        {dataCards?.map(({title, description, icon}, index) => (
                            <li className={styles.featureItem} key={index}>
                                <div className={styles.featureCard}>
                                    <div className={styles.cardIcon}>
                                        <img src={icon} width="100" height="80" loading="lazy" alt="icon"/>
                                    </div>
                                    <h3 className={styles.cardTitle}>{title}</h3>
                                    <p className={styles.cardText}>{description}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <img src="/assets/images/shape-8.png" width="197" height="194" loading="lazy" alt=""
                         className={`${styles.shape} ${styles.shape1}`}/>
                    <img src="/assets/images/shape-7.png" width="197" height="194" loading="lazy" alt=""
                         className={`${styles.shape} ${styles.shape5}`}/>
                </div>
            </div>
        </div>


    </div>
}
export default Booking;